import { useState } from "react";
import { Link } from "react-router-dom";

import { Drawer, Title } from "@components";

import { EnvironmentStorage } from "../shared/tools/EnvironmentStorage";
import styles from "../styles/settings.module.scss";

export default function Sales() {
  const [openAlert, setOpenAlert] = useState(false);

  const environment = EnvironmentStorage.getEnvironment();
  const pages = [
    {
      name: "Pedidos",
      icon: <i className="far fa-receipt" />,
      path: "/pedidos",
    },
    {
      name: "Configurações",
      icon: <i className="far fa-gear" />,
      path: "/configuracoes",
    },
  ];

  const getSubtitle = () => {
    if (environment?.brand)
      return (
        `${environment.brand.name} - ${environment.name}` +
        (environment.active === false ? " (Inativa)" : "")
      );
    return environment?.name;
  };

  return (
    <div className={styles.settingsContainer}>
      <Title title="Frentes de venda" subtitle={getSubtitle()} />

      <div className={styles.settings}>
        {pages.map((page, index) => {
          return (
            <Link to={page.path} key={index}>
              <div className={styles.setting} style={{ opacity: 1 }}>
                <div className={styles.icon}>{page.icon}</div>
                <p>{page.name}</p>
              </div>
            </Link>
          );
        })}
      </div>

      <Drawer
        visible={openAlert}
        onClose={() => setOpenAlert(false)}
        direction="center"
        title="Atenção"
        closeButton={false}
      >
        <p className={styles.message}>
          Esta página é acessível somente no modo unidade.
        </p>
      </Drawer>
    </div>
  );
}
